<template>
  <div v-frag>
    <CardIeaAppMain colorCard="#A7BA38" title="">
      <!-- <v-row> -->
      <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
        <v-btn
          class="mx-2"
          dark
          small
          color="success"
          @click="
            $router.push({
              name: 'Home',
            })
          "
        >
          Menú
        </v-btn>
        <br />
        <br />
        <v-col
          cols="12"
          xs="12"
          sm="12"
          md="12"
          xl="12"
          lg="12"
          v-if="active == 0"
        >
          <v-alert prominent type="info">
            Servicio temporalmente inactivo
          </v-alert>
        </v-col>
        <v-row v-else>
          <v-col sm="12" xs="12" md="4">
            <v-tabs v-model="tab">
              <v-tab key="chat">CHAT</v-tab>
              <v-tab key="contacts">CONTACT0S</v-tab>
              <v-tab key="new"><v-icon>mdi-comment-plus-outline</v-icon></v-tab>
            </v-tabs>
            <v-tabs-items v-model="tab">
              <v-tab-item key="chat">
                <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        v-model.trim="textSearch"
                        type="text"
                        no-details
                        label="Buscar chat"
                        :append-outer-icon="
                          textSearch
                            ? 'mdi-close'
                            : 'mdi-comment-search-outline'
                        "
                        @keyup.enter="addMessage(messageForm.content)"
                        @click:append-outer="
                          textSearch ? (textSearch = '') : attachFile()
                        "
                        hide-details
                      />
                    </v-col>

                    <v-col
                      style="max-height: 430px"
                      class="overflow-y-auto"
                      cols="12"
                      @scroll="handleScrollChats"
                    >
                      <v-alert type="info" dense v-if="chats.length == 0">
                        <div v-if="loading">Cargando mensajes...</div>
                        <div v-else>No tienes mensajes aún</div>
                      </v-alert>
                      <v-card class="mx-auto" v-else>
                        <v-list>
                          <v-list-item-group v-model="selectedChat">
                            <v-list-item
                              v-for="(item, index) in chats"
                              :key="index"
                              @click="getChat(item, true)"
                            >
                              <v-list-item-avatar
                                v-if="item.type == 'Individual'"
                                color="#8fc6dc"
                              >
                                <v-img
                                  :src="item.image"
                                  v-if="
                                    item.image !== null && item.image !== ''
                                  "
                                ></v-img>
                                <v-icon dark v-else>mdi-account</v-icon>
                              </v-list-item-avatar>
                              <v-list-item-avatar v-else color="#8fc6dc">
                                <v-img
                                  :src="item.image"
                                  v-if="
                                    item.image !== null && item.image !== ''
                                  "
                                ></v-img>
                                <v-icon dark v-else
                                  >mdi-account-multiple</v-icon
                                >
                              </v-list-item-avatar>
                              <v-list-item-content>
                                <v-list-item-title
                                  v-text="item.name"
                                ></v-list-item-title>
                                <small
                                  style="color: #095da1"
                                  v-if="
                                    item.last_message &&
                                    item.last_message.alumno != null
                                  "
                                  >{{ item.last_message.alumno.Nombres }}:
                                  {{
                                    item.last_message.message
                                      ? item.last_message.message.substring(
                                          0,
                                          10
                                        )
                                      : ""
                                  }}...
                                </small>

                                <small
                                  style="color: #095da1"
                                  v-else-if="
                                    item.last_message &&
                                    item.last_message.profesor != null
                                  "
                                  >{{
                                    item.last_message.profesor.empleado.nombres
                                  }}:
                                  {{
                                    item.last_message.message
                                      ? item.last_message.message.substring(
                                          0,
                                          10
                                        )
                                      : ""
                                  }}...
                                </small>
                              </v-list-item-content>
                              <v-list-item-action>
                                <v-btn icon v-if="item.silent">
                                  <v-icon color="grey lighten-1"
                                    >mdi-volume-off</v-icon
                                  >
                                </v-btn>

                                <small
                                  style="
                                    font-size: 70%;
                                    text-align: center;
                                    width: 100%;
                                  "
                                  v-if="item.last_message"
                                  >{{
                                    item.last_message.created_at.substr(11, 5)
                                  }}</small
                                >

                                <v-row>
                                  <v-col cols="6" v-if="item.fixed">
                                    <v-btn icon>
                                      <v-icon color="#a7ba38">mdi-pin</v-icon>
                                    </v-btn>
                                  </v-col>
                                  <v-col cols="6" v-if="item.notifications">
                                    <v-badge
                                      :content="item.notifications"
                                      bottom
                                      inline
                                      color="red"
                                    ></v-badge>
                                  </v-col>
                                </v-row>
                              </v-list-item-action>
                              <v-list-item-icon> </v-list-item-icon>
                            </v-list-item>
                          </v-list-item-group>
                        </v-list>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-col>
              </v-tab-item>
              <v-tab-item key="contacts">
                <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        v-model="textSearchContact"
                        label="Buscar contacto"
                        :append-outer-icon="
                          textSearchContact ? 'mdi-close' : 'mdi-account-search'
                        "
                        @click:append-outer="
                          textSearchContact ? cancelSearch() : loadContacts()
                        "
                        v-on:keydown="loadContacts()"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      style="max-height: 400px"
                      class="overflow-y-auto"
                      @scroll="handleScrollContacts"
                    >
                      <v-alert
                        type="info"
                        dense
                        v-if="contactsFiltered.length == 0"
                      >
                        Ninguna coincidencia
                      </v-alert>
                      <v-card class="mx-auto" v-else>
                        <v-list>
                          <v-list-item-group v-model="selectedContact">
                            <div
                              v-for="(data, letter) in contactsFiltered"
                              :key="letter"
                            >
                              <v-subheader>{{ letter }}</v-subheader>
                              <div v-for="(person, index) in data" :key="index">
                                <v-list-item
                                  @click="newChatIndividual(person)"
                                  v-if="person.IDStB !== user.IDStB"
                                >
                                  <v-list-item-avatar>
                                    <v-img
                                      :src="person.imagen"
                                      v-if="person.imagen"
                                    ></v-img>
                                    <v-icon color="#a7ba38" v-else
                                      >mdi-account</v-icon
                                    >
                                  </v-list-item-avatar>
                                  <v-list-item-content>
                                    <v-list-item-title
                                      v-text="person.Nombres"
                                    ></v-list-item-title>
                                  </v-list-item-content>
                                  <v-list-item-icon v-if="person.tipo_usuario == 'alumno'">
                                    <v-icon color="orange"
                                      >mdi-message-text</v-icon
                                    >
                                  </v-list-item-icon>

                                  <v-list-item-icon v-else-if="person.tipo_usuario == 'profesor'">
                                    <v-icon color="red"
                                      >mdi-message-text</v-icon
                                    >
                                  </v-list-item-icon>
                                </v-list-item>
                              </div>
                              <v-divider></v-divider>
                            </div>
                          </v-list-item-group>
                        </v-list>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-col>
              </v-tab-item>
              <v-tab-item key="new">
                <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
                  <v-list flat>
                    <v-list-item-group color="primary">
                      <v-list-item @click="showContacts()">
                        <v-list-item-icon>
                          <v-icon>mdi-comment-text</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title> Nuevo mensaje </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item @click="showGroupNew = true">
                        <v-list-item-icon>
                          <v-icon>mdi-account-multiple-plus</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title> Nuevo grupo </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <template>
                        <v-dialog
                          v-model="showGroupNew"
                          scrollable
                          max-width="600px"
                        >
                          <v-card>
                            <v-card-title> Información del grupo </v-card-title>

                            <div style="margin: 0 20px">
                              <v-form
                                ref="form"
                                v-model="valid"
                                lazy-validation
                              >
                                <v-row>
                                  <v-col cols="2">
                                    <v-badge
                                      color="primary"
                                      icon="mdi-plus"
                                      overlap
                                      avatar
                                      class="mr-5 mt-0"
                                      @click.native="uploadImageGroupNew()"
                                    >
                                      <v-avatar size="40" color="#8fc6dc">
                                        <v-img
                                          :src="imageNewGroup"
                                          v-if="imageNewGroup"
                                        ></v-img>
                                        <v-icon dark v-else>mdi-image</v-icon>
                                      </v-avatar>
                                    </v-badge>
                                  </v-col>
                                  <v-col cols="10">
                                    <v-text-field
                                      v-model.trim="nameNewGroup"
                                      :rules="[rules.required]"
                                      filled
                                      densed
                                      outlined
                                      label="Nombre del grupo"
                                    >
                                    </v-text-field>
                                  </v-col>
                                </v-row>
                              </v-form>
                              <v-row align="center" justify="start">
                                <v-col
                                  v-for="(selection, i) in selections"
                                  :key="selection.id"
                                  class="shrink"
                                  with="140"
                                >
                                  <v-badge
                                    color="grey"
                                    icon="mdi-close"
                                    overlap
                                    avatar
                                    class="mr-2 mt-0"
                                    @click.native="selected.splice(i, 1)"
                                  >
                                    <v-avatar
                                      size="30"
                                      style="margin-right: 10px"
                                      color="#a7ba38"
                                    >
                                      <img
                                        :src="selection.imagen"
                                        v-if="selection.imagen"
                                      />
                                      <v-icon v-else>mdi-account</v-icon>
                                    </v-avatar>
                                  </v-badge>
                                  <small style="text-align: center"
                                    >{{
                                      selection.Nombres.substr(0, 6).trim()
                                    }}...</small
                                  >
                                </v-col>
                              </v-row>
                            </div>
                            <v-card-text>
                              <v-text-field
                                v-model="textSearchContact"
                                label="Buscar contacto"
                                :append-outer-icon="
                                  textSearchContact
                                    ? 'mdi-close'
                                    : 'mdi-account-search'
                                "
                                @click:append-outer="
                                  textSearchContact
                                    ? cancelSearch()
                                    : loadContacts()
                                "
                                v-on:keydown="loadContacts()"
                              ></v-text-field>
                            </v-card-text>
                            <v-card-text
                              style="height: 300px"
                              @scroll="handleScrollContacts"
                            >
                              <div
                                v-for="(data, letter) in contactsFiltered"
                                :key="letter"
                              >
                                <v-subheader>{{ letter }}</v-subheader>
                                <div v-for="person in data" :key="person.IDStB">
                                  <v-list-item
                                    @click="selected.push(person)"
                                    v-if="
                                      !selected.includes(person) &&
                                      person.IDStB !== user.IDStB
                                    "
                                  >
                                    <v-list-item-avatar>
                                      <v-img
                                        :src="person.imagen"
                                        v-if="person.imagen"
                                      ></v-img>
                                      <v-icon color="#a7ba38" v-else
                                        >mdi-account</v-icon
                                      >
                                    </v-list-item-avatar>
                                    <v-list-item-content>
                                      <v-list-item-title
                                        v-text="person.Nombres"
                                      ></v-list-item-title>
                                    </v-list-item-content>
                                  </v-list-item>
                                </div>
                                <v-divider></v-divider>
                              </div>
                            </v-card-text>
                            <v-divider></v-divider>
                            <v-card-actions class="justify-space-around">
                              <v-btn
                                color="success darken-1"
                                @click="createGroup()"
                                small
                              >
                                <v-icon>mdi-chevron-right</v-icon> Finalizar
                              </v-btn>
                              <v-btn
                                color="blue darken-1"
                                text
                                @click="showGroupNew = false"
                                small
                              >
                                Cerrar
                              </v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                      </template>
                    </v-list-item-group>
                  </v-list>
                </v-col>
              </v-tab-item>
            </v-tabs-items>
          </v-col>
          <v-col xs="12" sm="12" md="8">
            <div v-if="chatActive">
              <v-responsive
                v-if="activeChat"
                class="overflow-y-hidden fill-height"
                height="560"
              >
                <v-card
                  flat
                  class="d-flex flex-column fill-height"
                  ref="contentchat"
                >
                  <v-card-title>
                    <v-avatar
                      size="50"
                      color="#8fc6dc"
                      title="Ver perfil"
                      @click="openProfile(chatActive.other_alumno)"
                    >
                      <v-img
                        :src="chatActive.image"
                        v-if="
                          chatActive.image !== null && chatActive.image !== ''
                        "
                        style="cursor: pointer"
                      ></v-img>
                      <v-icon v-else-if="chatActive.type == 'Individual'"
                        >mdi-account</v-icon
                      >
                      <v-icon v-else>mdi-account-multiple</v-icon>
                    </v-avatar>

                    <span class="ml-2">{{ chatActive.name }} </span>
                    <template v-if="chatActive.type == 'Group'">
                      <div class="text-center">
                        <v-menu offset-y>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              color="warning"
                              dark
                              fab
                              x-small
                              v-bind="attrs"
                              v-on="on"
                            >
                              <v-icon> mdi-dots-vertical </v-icon>
                            </v-btn>
                          </template>
                          <v-list>
                            <v-list-item @click="showGroup = true">
                              <v-list-item-title
                                >Ver participantes</v-list-item-title
                              >
                            </v-list-item>
                            <v-list-item @click="showReporte = true">
                              <v-list-item-title
                                >Reportar grupo</v-list-item-title
                              >
                            </v-list-item>
                            <v-list-item @click="silentGroup()">
                              <v-list-item-title>{{
                                chatActive.silent
                                  ? "Dejar de silenciar grupo"
                                  : "Silenciar grupo"
                              }}</v-list-item-title>
                            </v-list-item>
                            <v-list-item
                              @click="leaveChat()"
                              :disabled="chatActive.can_exit == 0"
                            >
                              <v-list-item-title
                                >Salir del grupo</v-list-item-title
                              >
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </div>
                    </template>
                  </v-card-title>

                  <v-card-text
                    class="overflow-y-auto pa-2"
                    style="
                      background-color: #f9f9f9;
                      border-radius: 10px;
                      overflow-x: hidden;
                    "
                    ref="chatMessages"
                    @scroll="scrollChat"
                  >
                    <div v-for="day in chatActive.messages" :key="day.day">
                      <p style="text-align: center">
                        <v-chip class="ma-2" small>
                          {{ day.day }}
                        </v-chip>
                      </p>
                      <v-divider class="mb-6"></v-divider>
                      <div v-for="msg in day.messages" :key="msg.id">
                        <div
                          v-if="(msg.active = 1)"
                          :class="{
                            'd-flex flex-row-reverse':
                              msg.user_id == user.IDStB,
                          }"
                        >
                          <v-menu offset-y>
                            <template v-slot:activator="{ on }">
                              <p v-if="msg.user_id == user.IDStB">
                                <v-card
                                  color="transparent"
                                  class="d-flex justify-end"
                                  flat
                                  tile
                                  v-if="msg.file"
                                >
                                  <a
                                    style="text-decoration: none"
                                    :href="msg.file"
                                    :download="msg.filename"
                                    target="_blank"
                                  >
                                    <v-sheet
                                      color="#d5ecf5"
                                      elevation="1"
                                      width="100"
                                      class="m-10 p-5 preview"
                                      rounded
                                      style="
                                        text-align: center;
                                        display: block;
                                        margin: 10px 0;
                                      "
                                    >
                                      <v-img
                                        :src="msg.file"
                                        width="100"
                                        v-if="msg.type == 'image'"
                                      ></v-img>
                                      <v-icon
                                        class="mt-5"
                                        size="50"
                                        color="red"
                                        v-if="
                                          msg.type && msg.type.match('pdf.*')
                                        "
                                        >mdi-file-pdf</v-icon
                                      >
                                      <v-icon
                                        class="mt-5"
                                        size="50"
                                        color="green"
                                        v-if="
                                          msg.type && msg.type.match('excel.*')
                                        "
                                        >mdi-file-excel</v-icon
                                      >
                                      <v-icon
                                        class="mt-5"
                                        size="50"
                                        color="blue"
                                        v-if="
                                          msg.type && msg.type.match('word.*')
                                        "
                                        >mdi-file-word</v-icon
                                      >
                                      <v-icon
                                        class="mt-5"
                                        size="50"
                                        color="orange"
                                        v-if="
                                          msg.type &&
                                          msg.type.match('presentation.*')
                                        "
                                        >mdi-file-powerpoint</v-icon
                                      >
                                      <v-icon
                                        class="mt-5"
                                        size="50"
                                        color="purple"
                                        v-if="
                                          msg.type && msg.type.match('video.*')
                                        "
                                        >mdi-file-video</v-icon
                                      >
                                      <p>
                                        <small class="m-5">{{
                                          msg.filename
                                        }}</small>
                                      </p>
                                    </v-sheet>
                                  </a>
                                </v-card>
                                <v-card
                                  color="transparent"
                                  class="d-flex justify-end mb-6"
                                  flat
                                  tile
                                  v-if="msg.resend"
                                >
                                  <small style="font-style: italic; color: grey"
                                    ><v-icon
                                      class="mt-5"
                                      size="18"
                                      style="margin-top: 0 !important"
                                      >mdi-reply</v-icon
                                    >
                                    Reenviado</small
                                  >
                                </v-card>

                                <v-card
                                  color="transparent"
                                  class="d-flex justify-end"
                                  flat
                                  tile
                                >
                                  <v-card
                                    color="#d5ecf5"
                                    style="border-radius: 10px 10px 0px"
                                    :elevation="1"
                                    class="pa-2"
                                    v-if="
                                      msg.message && msg.message.trim !== ''
                                    "
                                    v-html="msg.messageHtml"
                                  >
                                  </v-card>
                                </v-card>

                                <v-card
                                  color="transparent"
                                  class="d-flex justify-end mb-6"
                                  flat
                                  tile
                                >
                                  <small
                                    class="mt-2"
                                    style="font-size: 0.6rem; color: grey"
                                    >{{ msg.created_at.substr(11, 5) }}
                                    <span
                                      style="cursor: pointer"
                                      v-if="canDelete(msg.created_at)"
                                      @click="deleteMessage(msg)"
                                    >
                                      | Eliminar</span
                                    >
                                    <span
                                      style="cursor: pointer"
                                      @click="
                                        showResend = true;
                                        messageResend = msg.id;
                                      "
                                    >
                                      | Reenviar</span
                                    >
                                  </small>
                                </v-card>
                              </p>

                              <p v-else>
                                <v-row class="mb-1">
                                  <span v-if="chatActive.type == 'Group'">
                                    <small>
                                      <strong
                                        :style="{
                                          color: getColorParticipant(
                                            msg.alumno.IDStB
                                          ),
                                        }"
                                        >{{ msg.alumno.Nombres }}
                                        {{ msg.alumno.Apellidos }}</strong
                                      >
                                    </small>
                                  </span>
                                  <small
                                    class="ml-2 float-end"
                                    style="font-size: 0.6rem; color: grey"
                                    v-if="on"
                                  ></small>
                                </v-row>
                                <v-row class="mb-1">
                                  <small
                                    style="font-style: italic; color: grey"
                                    v-if="msg.resend"
                                    >Reenviado</small
                                  >
                                </v-row>
                                <v-row v-if="msg.file">
                                  <a
                                    style="text-decoration: none"
                                    :href="msg.file"
                                    :download="msg.filename"
                                    target="_blank"
                                  >
                                    <v-sheet
                                      color="white"
                                      elevation="1"
                                      width="100"
                                      class="m-10 p-5 preview"
                                      rounded
                                      style="
                                        color: grey;
                                        text-align: center;
                                        display: block;
                                        margin: 10px 0;
                                      "
                                    >
                                      <v-img
                                        :src="msg.file"
                                        width="100"
                                        v-if="msg.type == 'image'"
                                      ></v-img>
                                      <v-icon
                                        class="mt-5"
                                        size="50"
                                        color="red"
                                        v-if="msg.type.match('pdf.*')"
                                        >mdi-file-pdf</v-icon
                                      >
                                      <v-icon
                                        class="mt-5"
                                        size="50"
                                        color="green"
                                        v-if="msg.type.match('excel.*')"
                                        >mdi-file-excel</v-icon
                                      >
                                      <v-icon
                                        class="mt-5"
                                        size="50"
                                        color="blue"
                                        v-if="msg.type.match('word.*')"
                                        >mdi-file-word</v-icon
                                      >
                                      <v-icon
                                        class="mt-5"
                                        size="50"
                                        color="orange"
                                        v-if="msg.type.match('presentation.*')"
                                        >mdi-file-powerpoint</v-icon
                                      >
                                      <v-icon
                                        class="mt-5"
                                        size="50"
                                        color="purple"
                                        v-if="msg.type.match('video.*')"
                                        >mdi-file-video</v-icon
                                      >
                                      <p>
                                        <small class="m-5">{{
                                          msg.filename
                                        }}</small>
                                      </p>
                                    </v-sheet>
                                  </a>
                                </v-row>
                                <v-row>
                                  <v-card
                                    color="white"
                                    :elevation="1"
                                    text-color="#616161"
                                    class="pa-2 mb-2"
                                    style="border-radius: 10px 10px 10px 0px"
                                    v-if="
                                      msg.message && msg.message.trim !== ''
                                    "
                                    v-html="msg.messageHtml"
                                  >
                                  </v-card>
                                </v-row>
                                <v-row>
                                  <small
                                    class="mb-2"
                                    style="font-size: 0.6rem; color: grey"
                                    >{{ msg.created_at.substr(11, 5) }}
                                    <span
                                      style="cursor: pointer"
                                      @click="
                                        showResend = true;
                                        messageResend = msg.id;
                                      "
                                    >
                                      | Reenviar</span
                                    >
                                  </small>
                                </v-row>
                              </p>
                            </template>
                          </v-menu>
                        </div>
                      </div>
                    </div>
                  </v-card-text>

                  <v-card-text class="flex-shrink-1">
                    <div style="position: absolute; top: 50px">
                      <VEmojiPicker
                        class="elevation-1"
                        @select="selectEmoji"
                        emojiSize="25"
                        emojisByRow="9"
                        v-if="showEmojis"
                      />
                    </div>
                    <template>
                      <Mentionable
                        :keys="['@', '#']"
                        :items="chatActive.participants"
                        offset="6"
                        insert-space
                        @search="searchText = $event"
                        @open="openKey = $event"
                        @close="closeKey = $event"
                        @apply="(item, key) => selectItem(item)"
                      >
                        <v-text-field
                          v-model.trim="messageForm.content"
                          :label="
                            sendingMessage
                              ? 'Enviando mensaje...'
                              : 'Escribe un mensaje'
                          "
                          type="text"
                          no-details
                          :disabled="sendingMessage"
                          outlined
                          prepend-icon="mdi-emoticon"
                          :append-outer-icon="
                            messageForm.content ? 'mdi-send' : 'mdi-attachment'
                          "
                          @keyup.enter="addMessage(messageForm.content)"
                          @click:append-outer="
                            messageForm.content
                              ? addMessage(messageForm.content)
                              : attachFile()
                          "
                          @click:prepend="showEmojis = !showEmojis"
                          @click="showEmojis = false"
                          @focus="showEmojis = false"
                          hide-details
                          clear-icon="mdi-close-circle"
                          clearable
                        />
                        <template #no-result>
                          <div class="dim">No result</div>
                        </template>

                        <template #item-@="{ item }">
                          <div class="user">
                            <v-avatar size="25" color="#8fc6dc">
                              <v-img
                                :src="item.alumno.imagen"
                                v-if="item.alumno.imagen"
                              ></v-img>
                              <v-icon dark v-else size="15">mdi-account</v-icon>
                            </v-avatar>
                            {{ item.value }}
                          </div>
                        </template>
                      </Mentionable>
                    </template>
                  </v-card-text>
                </v-card>
              </v-responsive>
            </div>
          </v-col>
        </v-row>
      </v-col>

      <!-- </v-row> -->
      <ModalCustom
        :show="showAlert"
        @update="onUpdateShow"
        :content="contentAlert"
        :type="typeAlert"
      />
      <template>
        <v-dialog v-model="showReporte" max-width="490">
          <v-card>
            <v-card-title
              class="text-h5 justify-center modal-danger"
              style="color: white"
            >
              Reportar grupo
              <v-spacer></v-spacer>
              <v-btn icon dark @click="showReporte = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>

            <v-card-text>
              <p class="justify-center pt-5">
                <v-text-field
                  v-model="contentReport"
                  label="Escribe porque quieres reportar este grupo de chat"
                ></v-text-field>
              </p>
              <div class="box-container justify-center">
                <span class="box color1-logo"></span>
                <span class="box color2-logo"></span>
                <span class="box color3-logo"></span>
                <span class="box color4-logo"></span>
                <span class="box color5-logo"></span>
              </div>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="justify-space-around">
              <v-btn color="error darken-1" @click="reportChat()" small>
                <v-icon>mdi-alert-octagon</v-icon> Reportar
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                @click="showReporte = false"
                small
              >
                Cancelar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <input
          id="file-upload"
          type="file"
          v-on:change="addImageGroup()"
          ref="fileInputGroup"
          style="visibility: hidden"
        />
        <input
          id="file-upload"
          type="file"
          v-on:change="addImageGroupNew()"
          ref="fileInputGroupNew"
          style="visibility: hidden"
        />
        <input
          id="file-upload"
          type="file"
          v-on:change="addImageChat()"
          ref="fileInputChat"
          style="visibility: hidden"
        />
      </template>
      <template>
        <v-dialog
          v-model="showGroup"
          max-width="600px"
          scrollable
          v-if="chatActive"
        >
          <v-card>
            <v-card-title> Información del grupo </v-card-title>

            <v-list>
              <v-list-item>
                <v-badge
                  color="primary"
                  icon="mdi-pencil"
                  overlap
                  v-if="editGroup"
                  avatar
                  class="mr-5 mt-0"
                  @click.native="uploadImageGroup()"
                >
                  <v-avatar color="#8fc6dc" size="40">
                    <v-img
                      :src="chatActive.image"
                      v-if="
                        chatActive.image !== null && chatActive.image !== ''
                      "
                    ></v-img>
                    <v-icon v-else>mdi-account-multiple</v-icon>
                  </v-avatar>
                </v-badge>
                <v-list-item-avatar color="#8fc6dc" v-else>
                  <v-img
                    :src="chatActive.image"
                    v-if="chatActive.image !== null && chatActive.image !== ''"
                  ></v-img>
                  <v-icon v-else>mdi-account-multiple</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-text-field
                    v-model.trim="chatActive.name"
                    :rules="[rules.required]"
                    densed
                    placeholder="Nombre del grupo"
                    label="Nombre del grupo"
                    v-if="editGroup"
                  >
                  </v-text-field>
                  <v-list-item-title v-else>{{
                    chatActive.name
                  }}</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action v-if="isAdministrator()">
                  <v-btn
                    v-if="editGroup"
                    @click="saveGroup()"
                    color="primary"
                    title="Guardar"
                    icon
                  >
                    <v-icon>mdi-content-save</v-icon>
                  </v-btn>
                  <v-btn
                    v-else
                    dark
                    color="primary"
                    @click="editGroup = true"
                    title="Editar grupo"
                    icon
                  >
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                </v-list-item-action>
                <v-list-item-action v-if="isAdministrator()">
                  <v-btn
                    dark
                    color="primary"
                    @click="openMondalContacts()"
                    title="Agregar participantes"
                    icon
                  >
                    <v-icon>mdi-account-multiple-plus</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>

            <v-divider></v-divider>
            <v-card-text style="height: 300px">
              <v-list>
                <v-list-item
                  v-for="participant in chatActive.participants"
                  :key="participant.id"
                >
                  <div v-if="participant.alumno != null">

                     <v-list-item-avatar>
                    <v-list-item-avatar
                      color="#a7ba38"
                      title="Ver perfil"
                      @click="openProfile(participant.alumno.IDStB)"
                    >
                      <v-icon dark>mdi-account</v-icon>
                    </v-list-item-avatar>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title
                      >{{participant.alumno.Nombres}}
                      <v-chip
                        class="ma-2"
                        x-small
                        color="success"
                        outlined
                        v-if="participant.administrator"
                      >
                        Adminstrador
                      </v-chip></v-list-item-title
                    >
                  </v-list-item-content>

                  </div>
                  <div v-else>

                     <v-list-item-avatar>
                    <v-list-item-avatar
                      color="#a7ba38"
                      title="Ver perfil"
                      @click="openProfile(participant.profesor.IDStB)"
                    >
                      <v-icon dark>mdi-account</v-icon>
                    </v-list-item-avatar>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title
                      >{{participant.profesor.empleado == null  ? "Nombre no encontrado" : participant.profesor.empleado.nombres }}
                      <v-chip
                        class="ma-2"
                        x-small
                        color="success"
                        outlined
                        v-if="participant.administrator"
                      >
                        Adminstrador
                      </v-chip></v-list-item-title
                    >
                  </v-list-item-content>

                  </div>
                 
                  <v-list-item-action>
                    <v-btn
                      @click="deleteParticipant(participant)"
                      v-if="
                        isAdministrator() && participant.user_id !== user.IDStB
                      "
                      icon
                    >
                      <v-icon color="red lighten-1"
                        >mdi-close-circle-outline</v-icon
                      >
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="justify-space-around">
              <v-btn
                color="red darken-1"
                text
                @click="leaveChat()"
                small
                :disabled="chatActive.can_exit == 0"
              >
                <v-icon>mdi-exit-to-app</v-icon> Salir del grupo
              </v-btn>
              <v-btn
                color="red darken-1"
                text
                @click="showReporte = true"
                small
              >
                <v-icon>mdi-alert-octagon</v-icon> Reportar grupo
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                @click="closeDialogGroup()"
                small
              >
                Cerrar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <input
          id="file-upload"
          type="file"
          v-on:change="addImageGroup()"
          ref="fileInputGroup"
          style="visibility: hidden"
        />
        <input
          id="file-upload"
          type="file"
          @change="onFilesChange"
          ref="filesChat"
          style="visibility: hidden"
          multiple=""
        />
      </template>
      <template>
        <v-dialog v-model="showSearchContacts" max-width="500" scrollable>
          <v-card>
            <v-card-title class="text-h6 justify-center">
              Agregar participantes al grupo
              <v-spacer></v-spacer>
              <v-btn icon dark @click="showSearchContacts = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <v-text-field
                v-model="textSearchContact"
                label="Buscar contacto"
                :append-outer-icon="
                  textSearchContact ? 'mdi-close' : 'mdi-account-search'
                "
                @click:append-outer="
                  textSearchContact ? cancelSearch() : loadContacts()
                "
                v-on:keydown="loadContacts()"
              ></v-text-field>
            </v-card-text>
            <v-card-text style="height: 300px" @scroll="handleScrollContacts">
              <div v-for="(data, letter) in contactsFiltered" :key="letter">
                <v-subheader>{{ letter }}</v-subheader>
                <div v-for="person in data" :key="person.IDStB">
                  <v-list-item
                    v-if="
                      chatActive &&
                      chatActive.participants &&
                      chatActive.participants.filter((d) => {
                        return d.user_id == person.IDStB;
                      }).length == 0
                    "
                  >
                    <v-list-item-action>
                      <v-checkbox
                        :value="person"
                        v-model="contactsSelected"
                      ></v-checkbox>
                    </v-list-item-action>
                    <v-list-item-avatar class="mr-2">
                      <v-img :src="person.imagen" v-if="person.imagen"></v-img>
                      <v-icon color="#a7ba38" v-else>mdi-account</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title
                        v-html="person.Nombres"
                      ></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </div>
                <v-divider></v-divider>
              </div>
            </v-card-text>

            <v-card-text>
              <div class="box-container justify-center">
                <span class="box color1-logo"></span>
                <span class="box color2-logo"></span>
                <span class="box color3-logo"></span>
                <span class="box color4-logo"></span>
                <span class="box color5-logo"></span>
              </div>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="justify-space-around">
              <v-btn
                color="success darken-1"
                text
                @click="addParticipants()"
                small
              >
                Aceptar
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                @click="showSearchContacts = false"
                small
              >
                Cancelar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <input
          id="file-upload"
          type="file"
          v-on:change="addImageGroup()"
          ref="fileInputGroup"
          style="visibility: hidden"
        />
        <input
          id="file-upload"
          type="file"
          @change="onFilesChange"
          ref="filesChat"
          style="visibility: hidden"
          multiple=""
        />
      </template>
      <template>
        <v-dialog v-model="showImageAttach" max-width="825" scrollable>
          <v-card>
            <v-card-title
              class="text-h5 justify-center modal-info"
              style="color: white"
            >
              Adjuntar archivo
              <v-spacer></v-spacer>
              <v-btn icon dark @click="hiddeAttachDialog()">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>

            <v-card-text>
              <v-alert outlined dense type="info" class="mt-2">
                <small
                  >Tamaño máximo por archivo
                  <strong>{{ max_size_file }}MB</strong></small
                >
              </v-alert>
              <p>
                <v-row class="mt-2">
                  <div
                    v-for="(file, index) in messageForm.files"
                    :key="index"
                    style="text-align: center"
                  >
                    <v-chip
                      class="ma-4"
                      close
                      color="#f2f2f2"
                      close-icon="mdi-delete"
                      text-color="blue"
                      @click:close="deleteFileChatThumnail(index)"
                    >
                      <v-sheet
                        color="white"
                        elevation="1"
                        height="100"
                        width="100"
                        class="m-10 p-5 preview"
                      >
                        <div style="text-align: center">
                          <img
                            :src="file.url"
                            v-if="file.type.match('image.*')"
                          />
                          <v-icon
                            class="mt-5"
                            size="50"
                            color="red"
                            v-if="file.type.match('pdf.*')"
                            >mdi-file-pdf</v-icon
                          >
                          <v-icon
                            class="mt-5"
                            size="50"
                            color="green"
                            v-if="file.type.match('excel.*')"
                            >mdi-file-excel</v-icon
                          >
                          <v-icon
                            class="mt-5"
                            size="50"
                            color="blue"
                            v-if="file.type.match('word.*')"
                            >mdi-file-word</v-icon
                          >
                          <v-icon
                            class="mt-5"
                            size="50"
                            color="orange"
                            v-if="file.type.match('presentation.*')"
                            >mdi-file-powerpoint</v-icon
                          >
                          <v-icon
                            class="mt-5"
                            size="50"
                            color="purple"
                            v-if="file.type.match('video.*')"
                            >mdi-file-video</v-icon
                          >
                        </div>
                      </v-sheet>
                    </v-chip>
                    <p>
                      <small :title="file.name"
                        >{{
                          file.name.length > 30
                            ? file.name.substr(0, 20) + "..."
                            : file.name
                        }}
                      </small>
                    </p>
                  </div>
                </v-row>
                <v-text-field
                  v-model.trim="messageForm.content"
                  label="Escribe un mensaje"
                  type="text"
                  no-details
                  densed
                  append-outer-icon="mdi-send"
                  @keyup.enter="addMessage(messageForm.content)"
                  @click:append-outer="addMessage(messageForm.content)"
                  hide-details
                />
              </p>

              <div class="box-container justify-center">
                <span class="box color1-logo"></span>
                <span class="box color2-logo"></span>
                <span class="box color3-logo"></span>
                <span class="box color4-logo"></span>
                <span class="box color5-logo"></span>
              </div>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="justify-space-around">
              <v-btn
                color="blue darken-1"
                text
                @click="hiddeAttachDialog()"
                small
              >
                Cancelar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="showResend" scrollable max-width="600px">
          <v-card>
            <v-card-title> Reenviar mensaje a: </v-card-title>
            <v-card-text style="height: 300px">
              {{ messageResend }}
              <v-subheader>Chats recientes</v-subheader>
              <v-list-item v-for="(item, index) in chats" :key="index">
                <v-list-item-avatar
                  v-if="item.type == 'Individual'"
                  color="#8fc6dc"
                >
                  <v-img
                    :src="item.image"
                    v-if="item.image !== null && item.image !== ''"
                  ></v-img>
                  <v-icon dark v-else>mdi-account</v-icon>
                </v-list-item-avatar>
                <v-list-item-avatar v-else color="#8fc6dc">
                  <v-img
                    :src="item.image"
                    v-if="item.image !== null && item.image !== ''"
                  ></v-img>
                  <v-icon dark v-else>mdi-account-multiple</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title v-text="item.name"></v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn icon @click="resendMessage(item)">
                    <v-icon color="grey lighten-1">mdi-arrow-right-bold</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="justify-space-around">
              <v-btn
                color="blue darken-1"
                text
                @click="showResend = false"
                small
              >
                Cerrar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <input
          id="file-upload"
          type="file"
          v-on:change="addImageGroup()"
          ref="fileInputGroup"
          style="visibility: hidden"
        />
        <input
          id="file-upload"
          type="file"
          v-on:change="onFilesChange"
          ref="filesChat"
          style="visibility: hidden"
          multiple=""
        />
      </template>
      <v-snackbar v-model="snackbar.show">
        {{ snackbar.text }}

        <template v-slot:action="{ attrs }">
          <v-btn
            color="white"
            text
            v-bind="attrs"
            @click="snackbar.show = false"
          >
            Close
          </v-btn>
        </template>
      </v-snackbar>
    </CardIeaAppMain>
  </div>
</template>

<script>
// import CardIeaApp from "../../components/CardIeaApp";
import CardIeaAppMain from "../../components/CardIeaAppMain";
import ModalCustom from "../../components/ModalCustom";
import moment from "moment";
moment.locale("es");

import SocketConnection from "itoeste-socket";
import { DEBUG, API_SOCKET } from "../../../env";
import { VEmojiPicker } from "v-emoji-picker";
import { Mentionable } from "vue-mention";

export default {
  name: "ChatProfesor",
  components: {
    // CardIeaApp,
    CardIeaAppMain,
    ModalCustom,
    VEmojiPicker,
    Mentionable,
  },

  data: () => ({
    active: 1,
    title: "Chat",
    selectedChat: null,
    selectedContact: null,
    textSearch: "",
    textSearchContact: "",
    contentReport: "",
    tab: "chat",
    showGroup: false,
    showGroupNew: false,
    showResend: false,
    showReporte: false,
    showImageAttach: false,
    showEmojis: false,
    editGroup: false,
    nameNewGroup: "",
    imageNewGroup: null,
    selected: [],
    showSearchContacts: false,
    rules: {
      required: (value) => !!value || "Campo requerido",
      counter: (value) => value.length <= 20 || "Max 20 characters",
      email: (value) => {
        const pattern =
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Invalid e-mail.";
      },
    },
    valid: true,
    contacts: [],
    items: [],
    chatActive: null,
    silent: false,
    messageForm: {
      content: "",
      files: [],
    },
    snackbar: {
      show: false,
      text: "",
    },

    activeChat: 1,
    showAlert: false,
    contentAlert: "",
    typeAlert: "modal-success",
    current_page: 0,
    last_page: -1,
    current_page_chat: 0,
    last_page_chat: -1,
    ws: null,
    limit: 10,
    max_size_file: 30,
    sendingMessage: false,
    contactsSelected: [],
    current_page_contacts: 0,
    selecteds: [],
    messageResend: null,
    loading: false,
    first: false,
  }),
  mounted() {
    this.verifierStatus();
    this.loadChats();
    this.loadContacts();
    this.ws = SocketConnection(
      {
        debug: DEBUG,
        token: API_SOCKET,
        user: this.$store.getters.user.IDStB,
      },
      () => {}
    );
    let id = this.$route.params.id;
    if (id) {
      this.$API
        .get({
          url: "profesor/chats/" + id,
        })
        .then((chat) => {
          chat.messages = [];
          chat.notifications = 0;
          if (chat.type == "Individual") {
            let index = chat.participants.findIndex((d) => {
              return d.user_id !== this.user.IDStB;
            });
            if (index !== -1) {
              if (chat.participants[index].alumno == null) {
                chat.name =
                  chat.participants[index].profesor.empleado.nombres +
                  " " +
                  chat.participants[index].profesor.empleado.apellidos;
                chat.image = chat.participants[index].profesor.empleado.imagen;
                chat.other_alumno = chat.participants[index].profesor.IDStB;
              } else {
                chat.name =
                  chat.participants[index].alumno.Nombres +
                  " " +
                  chat.participants[index].alumno.Apellidos;
                chat.image = chat.participants[index].alumno.imagen;
                chat.other_alumno = chat.participants[index].alumno.IDStB;
              }
            }
          }
          chat.participants = chat.participants.map((v) => {
            return { ...v, value: v.alumno.IDStB };
          });
          this.getChat(chat, true);
        });
    }
    let userid = this.$route.params.userid;
    if (userid) {
      this.$API
        .get({
          url: "profile/" + userid,
        })
        .then((res) => {
          this.newChatIndividual(res);
        });
    }

    this.ws.subscribeChannel("chat-" + this.user.IDStB, (result) => {
      console.log("llego por curl");
      console.log(result);
      switch (result.action) {
        case "chat-new":
          //Acaban de incluirlo en un chat
          this.onReceiveChat(result);
          this.playSound();
          break;
        case "chat-update":
          //Acaban de incluirlo en un chat
          this.onUpdateChat(result);
          break;
        case "participant-new":
          //Acaban de incluirlo en un chat
          this.onAddParticipant(result);
          break;
        case "participant-delete":
          //Acaban de incluirlo en un chat
          this.onDeleteParticipant(result);
          break;
        case "message-new":
          //Acaba de recibir un nnuevo mensaje
          this.onReceiveMessage(JSON.parse(result.message));
          break;
        case "chat-leave":
          //Alquien acaba de abandonar un chat
          this.onLeaveChat(result);
          break;
        case "message-delete":
          //Alquien acaba de abandonar un chat
          this.onDeleteMessage(result);
          break;
      }
    });

    /*this.ws.onReceiveChatAction((result) => {
      if(result.action){
        switch (result.action){
          case "message-new":
            //Acaba de recibir un nnuevo mensaje
            this.receiveMessage(result.data)
          break;
          case "chat-leave":
            //Alquien acaba de abandonar un chat
            this.receiveLeaveChat(result.data)
          break;
        }
      }
    });*/
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    selections() {
      const selections = [];

      for (const selection of this.selected) {
        selections.push(selection);
      }

      return selections;
    },
    chats() {
      const chats = [];
      let self = this;
      for (const chat of this.items) {
        if (chat.type == "Individual") {
          let index = chat.participants.findIndex((d) => {
            return d.user_id !== self.user.IDStB;
          });
          if (index !== -1) {
              if (chat.participants[index].alumno == null) {
                chat.name =
                  chat.participants[index].profesor.empleado.nombres +
                  " " +
                  chat.participants[index].profesor.empleado.apellidos;
                chat.image = chat.participants[index].profesor.empleado.imagen;
                chat.other_alumno = chat.participants[index].profesor.IDStB;
              } else {
                chat.name =
                  chat.participants[index].alumno.Nombres +
                  " " +
                  chat.participants[index].alumno.Apellidos;
                chat.image = chat.participants[index].alumno.imagen;
                chat.other_alumno = chat.participants[index].alumno.IDStB;
              }
            }
          chat.silent = chat.participants.filter((d) => {
            return d.user_id == this.user.IDStB;
          })[0].silent;
        }
        if (this.textSearch) {
          //let res = chat.messages.filter(d => {return (d.message.toUpperCase().search(this.textSearch.toUpperCase()) != -1)});
          let res2 = chat.participants.filter((d) => {
            return (
              d.alumno.Nombres.toUpperCase().search(
                this.textSearch.toUpperCase()
              ) != -1
            );
          });
          let res3 = chat.name
            .toUpperCase()
            .search(this.textSearch.toUpperCase());

          if (res2.length > 0 || res3 != -1) {
            chats.push(chat);
          }
        } else {
          chats.push(chat);
        }
      }

      return chats;
    },
    contactsFiltered() {
      if (this.textSearchContact) {
        return this.contacts;
      } else {
        return this.contacts;
      }
    },
  },

  methods: {
    selectItem(item) {
      this.selecteds.push(item);
    },

    playSound() {
      const sound = require("@/assets/notification.mp3");
      var audio = new Audio(sound);
      audio.play();
    },
    async verifierStatus() {
      this.$API
        .get({
          url: "profesor/chats-service-status",
        })
        .then((res) => {
          this.active = res;
        });
    },
    selectEmoji(emoji) {
      this.messageForm.content += emoji.data;
    },
    scrollChat() {
      if (this.chatActive && this.$refs.chatMessages && this.first) {
        this.$refs.chatMessages.scrollTop =
          this.$refs.chatMessages.scrollHeight;
        this.first = false;
      }
    },
    getType_(file) {
      let alloweds = [
        { t: "pdf", c: "red" },
        { t: "word", c: "blue" },
        { t: "image", c: null },
        { t: "video", c: "purple" },
        { t: "excel", c: "green" },
        { t: "presentation", c: "orange" },
      ];
      let type = null;
      alloweds.forEach((allowed) => {
        if (file.type.match(allowed.t + ".*")) {
          type = allowed;
        }
      });
      return type;
    },
    isAllowed(file) {
      let alloweds = ["pdf", "word", "image", "video", "excel", "presentation"];
      let allowed = false;
      alloweds.forEach((mime) => {
        if (file.type.match(mime + ".*")) {
          allowed = true;
        }
      });
      return allowed;
    },
    hasAllowedSize(file) {
      let allowed = false;
      let limit = this.max_size_file * 1024 * 1024;
      if (file.size <= limit) {
        allowed = true;
      }
      return allowed;
    },
    getType(file) {
      let alloweds = ["pdf", "word", "image", "video", "excel", "presentation"];
      let type = "";
      alloweds.forEach((mime) => {
        if (file.type.match(mime + ".*")) {
          type = mime;
        }
      });
      return type;
    },

    //Atrapa el evento cuando te incluyen en un chat
    onReceiveChat(data) {
      let e = this.items.findIndex((d) => {
        return d.id == data.chat_id;
      });

      if (e == -1) {
        let ch = JSON.parse(data.chat);

        this.items.unshift(ch);
      }
    },

    //Atrapa el evento cuando se edita un grupo
    onUpdateChat(data) {
      let e = this.items.findIndex((d) => {
        return d.id == data.chat_id;
      });
      let ch = JSON.parse(data.chat);
      if (e !== -1) {
        this.loadChats(true);
        if (this.chatActive && this.chatActive.id == data.chat_id) {
          this.chatActive = ch;
        }
      } else {
        this.items.unshift(ch);
      }
    },
    //Atrapa el evento cuando se abandona un grupo o se elimina un participantte
    onDeleteParticipant(data) {
      let e = this.items.findIndex((d) => {
        return d.id == data.chat_id;
      });
      let ch = JSON.parse(data.chat);
      let us = JSON.parse(data.participant);
      if (e !== -1) {
        this.loadChats(true);
        if (this.chatActive && this.chatActive.id == data.chat_id) {
          this.chatActive = ch;
        }
        this.snackbar.show = true;
        this.snackbar.text =
          "El usuario " + us.Nombres + " dejó la sala de chat " + ch.name;
      }
    },

    //Atrapa el evento cuando se agrega a  un grupo un participante
    onAddParticipant(data) {
      let e = this.items.findIndex((d) => {
        return d.id == data.chat_id;
      });
      let ch = JSON.parse(data.chat);
      if (e !== -1) {
        this.loadChats(true);
        if (this.chatActive && this.chatActive.id == data.chat_id) {
          this.chatActive = ch;
        }
        this.snackbar.show = true;
        this.snackbar.text =
          "Se agregaron nuevos participantes a sala de chat " + ch.name;
      } else {
        this.items.unshift(ch);
        this.snackbar.show = true;
        this.snackbar.text = "Fuiste agregado a la sala de chat " + ch.name;
      }
    },

    //Atrapa el evento cuando se agrega un mensaje
    onReceiveMessage(data) {
      if (this.user.IDStB != data.user_id) {
        this.playSound();
      }
      data.messageHtml = data.message;
      if (data.taggeds && data.taggeds.length > 0) {
        let u = this.getUrlBase();
        data.taggeds.forEach((val) => {
          let t = new Date().getTime();
          data.messageHtml = data.messageHtml.replace(
            val.shortName.trim(),
            '<a class="tagged" href="' +
              u +
              "/user/" +
              val.IDStB +
              "?t=" +
              t +
              '">' +
              val.shortName.trim() +
              "</a>"
          );
        });
      }
      let e = this.items.findIndex((d) => {
        return d.id == data.chat_id;
      });
      if (e !== -1) {
        let chRec = this.items[e];
        if (this.chatActive) {
          if (this.chatActive.id == chRec.id) {
            let existDay = this.chatActive.messages.findIndex((d) => {
              return d.day == "HOY";
            });
            if (existDay !== -1) {
              console.log("data");
              console.log(data);
              this.chatActive.messages[existDay].messages.push(data);
            } else {
              this.chatActive.messages.push({ day: "HOY", messages: [data] });
            }

            this.chatActive.last_message = data;
          } else {
            chRec.notifications++;
            chRec.last_message = data;
          }
        } else {
          chRec.notifications++;
          chRec.last_message = data;
        }

        this.items.splice(e, 1);
        this.items.unshift(chRec);
      } else {
        this.loadChats(true);
      }
      this.scrollChat();

      //console.log('llego mensaje', data)
    },
    onDeleteMessage(data) {
      let e = this.items.findIndex((d) => {
        return d.id == data.chat_id;
      });

      if (e !== -1) {
        let chRec = this.items[e];
        if (this.chatActive && this.chatActive.id == chRec.id) {
          let existDay = this.chatActive.messages.findIndex((d) => {
            return d.day == "HOY";
          });
          if (existDay !== -1) {
            let i = this.chatActive.messages[existDay].messages.findIndex(
              (d) => {
                return d.id == data.message_id;
              }
            );
            this.chatActive.messages[existDay].messages.splice(i, 1);
          }
        }
      }

      //console.log('llego mensaje', data)
    },
    onLeaveChat(data) {
      let e = this.items.findIndex((d) => {
        return d.id == data.chat_id;
      });
      if (e !== -1) {
        let ch = JSON.parse(data.chat);
        let us = JSON.parse(data.participant);
        this.loadChats(true);
        if (this.chatActive && this.chatActive.id == data.chat_id) {
          this.chatActive = ch;
        }
        this.snackbar.show = true;
        this.snackbar.text =
          "El usuario " + us.Nombres + " abandonó la sala de chat " + ch.name;
      }
    },
    isAdministrator() {
      return this.chatActive.participants.filter((d) => {
        return d.user_id == this.user.IDStB && d.administrator == 1;
      }).length > 0
        ? true
        : false;
    },
    gettime(date_publish) {
      let current_date = moment();
      let published_date = moment(date_publish);
      return moment.duration(current_date - published_date).humanize();
    },
    createFormData(formData, key, data) {
      if (data === Object(data) || Array.isArray(data)) {
        for (var i in data) {
          this.createFormData(formData, key + "[" + i + "]", data[i]);
        }
      } else {
        formData.append(key, data);
      }
    },

    async addMessage(content) {
      let contador = 0;
      if (content || this.messageForm.files.length > 0) {
        if (this.chatActive.id) {
          this.sendMessage(this.chatActive.id, content);
        } else {
          //Se crea primero el chat
          var formData = new FormData();
          this.chatActive.participants.forEach((p) => {
            let d = {
              IDStB: p.IDStB,
              typeUser: p.tipo_usuario,
            };

            this.createFormData(formData, `participants[${contador}]`, d);

            contador++;
            //formData.append('participants[]',d);
          });

          formData.append("type", "Individual");
          await this.$API
            .post(
              {
                url: "profesor/chats",
                data: formData,
              },
              false
            )
            .then((res) => {
              const existChat = (element) => element.id == res.id;
              let index = this.items.findIndex(existChat);

              this.items.splice(index, 1);
              this.items.unshift(res);

              this.chatActive = res;
              this.sendMessage(res.id, content);
            });
        }
      }
    },
    async addParticipants() {
      if (this.contactsSelected.length > 0) {
        await this.$API
          .post(
            {
              url: "profesor/chats/participants/" + this.chatActive.id,
              data: { participants: this.contactsSelected },
            },
            false
          )
          .then((res) => {
            this.showSearchContacts = false;
            this.contactsSelected = [];
            this.chatActive.participants = res;
          });
      }
    },
    async attachFile() {
      this.$refs.filesChat.click();
    },
    onFilesChange(e) {
      let all = e.target.files;

      if (all.length > 0) {
        all.forEach((val) => {
          if (this.messageForm.files.length < this.limit) {
            //if( val.type.match('image.*')){
            val.url = URL.createObjectURL(val);
            if (this.isAllowed(val) && this.hasAllowedSize(val)) {
              this.messageForm.files.push(val);
            }
          }
        });
        if (this.messageForm.files.length > 0) {
          this.showImageAttach = true;
        } else {
          this.showAlert = true;
          this.contentAlert = "Imposible enviar esos archivos";
          this.typeAlert = "modal-danger";
        }
      }
    },
    hiddeAttachDialog() {
      this.showImageAttach = false;
      this.messageForm.files = [];
    },
    deleteFileChatThumnail(index) {
      this.messageForm.files.splice(index, 1);
    },
    async sendMessage(chatId, message) {
      this.sendingMessage = true;
      if (this.messageForm.files.length > 0) {
        this.messageForm.files.forEach((file, index) => {
          var formData = new FormData();
          if (index == 0 && message) {
            formData.append("message", message);
          }
          formData.append("file", file);
          formData.append("type", this.getType(file));
          this.$API
            .post(
              {
                url: "profesor/chats/messages/" + chatId,
                data: formData,
              },
              false
            )
            .then(() => {
              //this.ws.chatAction('message-new', res)
              this.messageForm.content = "";
              this.tab = 0;
              this.sendingMessage = false;
              this.messageForm.files = [];
              this.selecteds = [];
              this.messageResend = null;
            });
        });
      } else {
        if (message) {
          var formData = new FormData();
          if (this.selecteds.length > 0) {
            let taggeds = new Array();
            this.selecteds.forEach((val) => {
              if (message.includes(val.value)) {
                taggeds.push(val.alumno.IDStB);
              }
            });
            formData.append("tagged", taggeds.join(","));
          }

          formData.append("message", message);
          this.$API
            .post(
              {
                url: "profesor/chats/messages/" + chatId,
                data: formData,
              },
              false
            )
            .then(() => {
              //this.ws.sendMessage(res)
              //this.ws.chatAction('message-new', res)

              this.messageForm.content = "";
              this.tab = 0;
              this.sendingMessage = false;
              this.messageForm.files = [];
              this.selecteds = [];
              this.messageResend = null;
            });
        }
      }

      this.showImageAttach = false;
    },

    onUpdateShow(newData) {
      this.showAlert = newData;
    },
    showContacts() {
      this.tab = 1;
    },
    showUsersChat() {},
    async getChat(chat, reload = false) {
      chat.notifications = 0;
      console.log('Contenido del chat', chat)
      this.chatActive = chat;
      let today = moment().format("YYYY-MM-DD");
      this.$API
        .get({
          url:
            "profesor/chats/messages/" +
            chat.id +
            "?page=" +
            this.current_page_chat,
        })
        .then((res) => {
          let days = [];
          for (const message of res.data.reverse()) {
            let day = message.created_at.substr(0, 10);
            day = today == day ? "HOY" : day;
            let exist = days.findIndex((d) => {
              return d.day == day;
            });
            message.messageHtml = message.message;
            if (message.taggeds && message.taggeds.length > 0) {
              let u = this.getUrlBase();
              message.taggeds.forEach((val) => {
                let t = new Date().getTime();
                message.messageHtml = message.messageHtml.replace(
                  val.shortName.trim(),
                  '<a class="tagged" href="' +
                    u +
                    "/user/" +
                    val.IDStB +
                    "?t=" +
                    t +
                    '">' +
                    val.shortName.trim() +
                    "</a>"
                );
              });
            }
            if (exist !== -1) {
              days[exist].messages.push(message);
            } else {
              days.push({ day: day, messages: [message] });
            }
          }

          if (reload) {
            this.chatActive.messages = days;
          } else {
            this.chatActive.messages(...days);
          }

          this.chatActive.participants = this.chatActive.participants.map(
            (v) => {
              if (v.alumno == null) {
                return {
                  ...v,
                  value: v.profesor.empleado.nombres.trim().replace(" ", "."),
                };
              } else {
                return {
                  ...v,
                  value: v.alumno.Nombres.trim().replace(" ", "."),
                };
              }
            }
          );
          this.chatActive.silent = this.chatActive.participants.filter((d) => {
            return d.user_id == this.user.IDStB;
          })[0].silent;
          console.log(this.chatActive);

          this.current_page = res.current_page_chat;
          this.last_page = res.last_page_chat;
          //this.loading = false;
          this.first = true;
        });
    },
    clearGroupDialog() {
      this.nameNewGroup = "";
      this.selected = [];
    },
    async createGroup() {
      let contador = 0;
      this.$refs.form.validate();
      if (this.valid) {
        if (this.selected.length <= 1) {
          this.showAlert = true;
          this.contentAlert = "Selecciona al menos dos participantes";
          this.typeAlert = "modal-primary";
        } else {
          var formData = new FormData();
          formData.append("name", this.nameNewGroup);
          formData.append("type", "Group");
          this.selected.forEach((participant) => {
            let d = {
              IDStB: participant.IDStB,
              typeUser: participant.tipo_usuario,
            };

            this.createFormData(formData, `participants[${contador}]`, d);

            contador++;
            //formData.append('participants[]', participant.IDStB);
          });

          if (this.$refs.fileInputGroupNew.files[0]) {
            formData.append("image", this.$refs.fileInputGroupNew.files[0]);
          }
          await this.$API
            .post({
              url: "profesor/chats",
              data: formData,
            })
            .then((res) => {
              if (res) {
                /*
                        res.participants.forEach((participant) => {
                            
                        });
                        */
                //this.ws.registerRooms([res.id], this.user.IDStB);

                //this.items.unshift(res);
                this.showGroupNew = false;
                this.tab = 0;
                this.selectedChat = 0;
                this.getChat(res);
                this.clearGroupDialog();
              }
            });
        }
      } else {
        this.showAlert = true;
        this.contentAlert = "Ingresa el nombre del grupo";
        this.typeAlert = "modal-primary";
      }
    },
    async uploadImageGroup() {
      this.$refs.fileInputGroup.click();
    },

    async uploadImageGroupNew() {
      this.$refs.fileInputGroupNew.click();
    },
    addImageGroup() {
      let val = this.$refs.fileInputGroup.files[0];
      if (val.type.match("image.*")) {
        val.url = URL.createObjectURL(val);
        this.chatActive.image = val.url;
      }
    },
    addImageGroupNew() {
      let val = this.$refs.fileInputGroupNew.files[0];
      if (val.type.match("image.*")) {
        val.url = URL.createObjectURL(val);
        this.imageNewGroup = val.url;
      }
    },
    getUrlBase() {
      var getUrl = window.location;
      var baseUrl =
        getUrl.protocol +
        "//" +
        getUrl.host +
        "/" +
        getUrl.pathname.split("/")[1];
      console.log(baseUrl);
      return baseUrl;
    },
    async saveGroup() {
      var formData = new FormData();
      formData.append("name", this.chatActive.name);
      if (this.$refs.fileInputGroup.files[0]) {
        formData.append("image", this.$refs.fileInputGroup.files[0]);
      }
      await this.$API
        .post({
          url: "profesor/chats/" + this.chatActive.id,
          data: formData,
        })
        .then((res) => {
          if (res) {
            this.editGroup = false;
          }
        });
    },
    closeDialogGroup() {
      if (this.editGroup) {
        if (
          confirm(
            "Aún no has guardado los datos del grupo, realmente deseas cerrar la ventana?"
          )
        ) {
          this.showGroup = false;
          this.editGroup = false;
        }
      } else {
        this.showGroup = false;
        this.editGroup = false;
      }
    },
    async leaveChat() {
      if (confirm("¿Estas seguro de querer salirte de este chat?")) {
        await this.$API
          .post({
            url: "profesor/chats/leave/" + this.chatActive.id,
          })
          .then((res) => {
            if (res == true) {
              this.chatActive = null;
              this.current_page = 0;
              this.loadChats(true);
              this.showGroup = false;
            }
          });
      }
    },
    async reportChat() {
      if (confirm("¿Estas seguro de querer reportar este chat?")) {
        await this.$API
          .post({
            url: "chat/report/" + this.chatActive.id,
            data: { message: this.contentReport },
          })
          .then((res) => {
            console.log(res);
            this.showReporte = false;
          });
      }
    },
    async silentGroup() {
      await this.$API
        .post({
          url: "profesor/chats/toggle-silent/" + this.chatActive.id,
          data: {},
        })
        .then((res) => {
          this.chatActive.participants.filter((d) => {
            return d.user_id == this.user.IDStB;
          })[0].silent = res.silent;
          this.chatActive.silent = res.silent;
          console.log(res);
        });
    },
    async deleteParticipant(participant) {

      let pregunta = participant.typeUser == 'alumno' ?   "¿Estas seguro de querer eliminar a " +
            participant.alumno.Nombres +
            " " +
            participant.alumno.Apellidos +
            " de este chat?" : " ¿ Está seguro de eliminar a este participante ? "

      if (
        confirm(
          pregunta
        )
      ) {
        await this.$API
          .delete({
            url: "profesor/chat-participant/" + participant.id,
          })
          .then((res) => {
            if (res) {
              this.chatActive.participants =
                this.chatActive.participants.filter((d) => {
                  return d.id != participant.id;
                });
            }
          });
      }
    },
    async deleteMessage(message) {
      if (confirm("¿Estas seguro de querer eliminar este mensaje?")) {
        await this.$API.delete({
          url: "chat-message/" + message.id,
        });
      }
    },
    canDelete(date) {
      let d = moment(date);
      let today = moment();
      return today.diff(d, "hours") <= 1 ? true : false;
    },
    newChatIndividual(person) {
      const today = new Date();
      let item = {
        name: person.Nombres,
        image: person.imagen,
        participants: [person],
        created_at: today.getHours() + ":" + today.getMinutes(),
        type: "Individual",
        messages: [],
        alumno: this.user,
      };
      console.log(item);
      this.chatActive = item;
      //this.items.unshift(item);
      //this.tab=0;
      //this.selectedChat=0;
      //this.getChat(item);
    },
    async loadChats(reload = false) {
      if (this.current_page !== this.last_page || reload) {
        if (reload) {
          this.current_page = 0;
        }
        this.loading = true;
        this.current_page++;
        this.$API
          .get({
            url: "profesor/chats?page=" + this.current_page,
          })
          .then((res) => {
            //let rooms=[];
            res.data.map(function (value) {
              value.messages = [];
              value.notifications = 0;
              //rooms.push(value.id);
            });
            //this.ws.registerRooms(rooms, this.user.IDStB);
            if (reload) {
              this.items = res.data;
            } else {
              this.items.push(...res.data);
            }

            this.current_page = res.current_page;
            this.last_page = res.last_page;
            this.loading = false;
          });
      }
    },
    async loadContacts(reload = true) {
      //this.loading = true;
      this.current_page_contacts++;
      let urlSearch = this.textSearchContact
        ? "&search=" + this.textSearchContact
        : "";
      this.$API
        .get({
          url:
            "profesor/contacts?paginate=1&page=" +
            this.current_page_contacts +
            urlSearch,
        })
        .then((res) => {
          //this.loading = false;
          if (reload) {
            this.contacts = res;
            this.current_page_contacts = 0;
          } else {
            this.contacts = { ...this.contacts, ...res };
          }
        });
    },
    async resendMessage(chat) {
      this.$API
        .post(
          {
            url: "porfesor/chats/resend/" + chat.id,
            data: {
              messageId: this.messageResend,
            },
          },
          false
        )
        .then(() => {
          //this.ws.sendMessage(res)
          //this.ws.chatAction('message-new', res)

          this.messageForm.content = "";
          this.tab = 0;
          this.sendingMessage = false;
          this.messageForm.files = [];
          this.selecteds = [];
          this.messageResend = null;
          this.showResend = false;
          this.getChat(chat);
        });
    },
    cancelSearch() {
      this.textSearchContact = "";
      this.loadContacts();
    },
    getColorParticipant(id) {
      let p = this.chatActive.participants.filter((d) => {
        return d.user_id == id;
      });
      return p.length > 0 ? p[0].color : "black";
    },
    openMondalContacts() {
      this.showSearchContacts = true;
    },
    handleScrollContacts(el) {
      if (
        el.target.offsetHeight + el.target.scrollTop >=
        el.target.scrollHeight
      ) {
        this.loadContacts(false);
      }
    },
    handleScrollChats(el) {
      if (
        el.target.offsetHeight + el.target.scrollTop >=
        el.target.scrollHeight
      ) {
        this.loadChats(false);
      }
    },

    openProfile(id) {
      if (id) {
        this.$router.push({
          name: "Profile",
          params: {
            id: id,
          },
        });
      }
    },
  },
};
</script>
